import {
  FormPrefillEntryFragment,
  InputElementFragment,
} from "__generated__/graphqlUnauthenticated";

export const mapToInitialValues = (
  elements: InputElementFragment[] = [],
  prefill: FormPrefillEntryFragment[],
  urlParams?: URLSearchParams,
) => {
  const initialValues = elements.reduce((initialValues, element) => {
    if (element.id && element.__typename === "InputElement") {
      const prefillValue = prefill.find(
        (prefill) => prefill.formElementId === element.id,
      )?.value;
      initialValues[element.id] = prefillValue || element.defaultValue;

      if (urlParams) {
        const urlParamsValue = urlParams.get(element.field);
        //gives precedence to prefill values over URL parameters
        if (urlParamsValue && !initialValues[element.id]) {
          initialValues[element.id] = urlParamsValue;
        }
      }
    }
    return initialValues;
  }, {});
  return initialValues;
};
